/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Kiotviet_Link_Order_Stocked_OutInputs */

const vi_error_kiotviet_link_order_stocked_out = /** @type {(inputs: Error_Kiotviet_Link_Order_Stocked_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đơn đã xuất kho nên không nối lại sản phẩm được nữa.`)
};

/**

* @param {Error_Kiotviet_Link_Order_Stocked_OutInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const error_kiotviet_link_order_stocked_out = /** @type {((inputs?: Error_Kiotviet_Link_Order_Stocked_OutInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Kiotviet_Link_Order_Stocked_OutInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_error_kiotviet_link_order_stocked_out(inputs)
});